export enum EChild {
  TopCardInput = 'TopCardInput',
  TopCardButton = 'TopCardButton',
  BottomCardButton = 'BottomCardButton',
}
